import type { ApiRequestFn } from "../../types/api";
import type { AdminScrapingSchedule, ScrapingScheduleResponse } from "../../types/scraping";

const createScrapingScheduleApi = (request: ApiRequestFn) => ({
  get: () => request<ScrapingScheduleResponse>("/me/scraping-schedule"),

  getAll: () => request<AdminScrapingSchedule[]>("/admin/scraping-schedules"),

  update: (scrapingTime: string | null, minInvoiceAmount?: number | null) =>
    request<{ success: boolean; scrapingTime: string | null; minInvoiceAmount: number | null }>("/me/scraping-schedule", {
      method: "PUT",
      body: JSON.stringify({ scrapingTime, ...(minInvoiceAmount !== undefined ? { minInvoiceAmount } : {}) }),
    }),
});

export { createScrapingScheduleApi };
